import styled from 'styled-components';

export const FooterContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100vw;
    height: 200px;
    background: #00A699;

    a {
        color: white;
    }
`;

export const FooterContent1 = styled.div`
    width: 300px;
`;

export const FooterContent2 = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 200px;
`;